// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "ridea/npm/js/" + {"1095":"71b794e9bbda8161","2749":"65474cd1467d97c9","3113":"55e2cb6e383e9a34","3761":"56f81bf7f0bca0ab","4202":"0f2bb53ae01f2367","5981":"4aa6c50918754e3c","7977":"3c86dd976cc6bdf0","8122":"fd3bb0f98e5976a2","8181":"24f182a544764f65"}[chunkId] + ".js";
};